export default __webpack_public_path__ + "static/kurorty-img-4-26f31a3a186f7d88444d9888ebf41f0d.png";